import { httpClient as e } from "../../../utils/http-client.mjs";
import { useQuery as t, useQueryClient as n } from "@tanstack/react-query";
//#region src/modules/file-selector/hooks/use-file-details.ts
var r = ({ id: r, fileManagerApiType: i }, a) => {
	let o = n(), s = ["file-details", { id: r }], c = () => i?.isCommon ? "/api/dashboard/management/data-files/" : "/api/dashboard/customer/data-files/", l = t({
		queryKey: s,
		retry: !1,
		refetchInterval: !1,
		refetchOnWindowFocus: !1,
		enabled: r !== void 0,
		queryFn: async ({ queryKey: t }) => {
			let [, { id: n }] = t;
			return (await e.get(c() + n)).data;
		},
		...a
	}), u = () => {
		o.invalidateQueries({ queryKey: s });
	};
	return {
		...l,
		resetAndRefetch: u
	};
};
//#endregion
export { r as useFileDetails };
